import React, { Fragment, useState } from "react";
import DropFile from "../DropFile";
import CustomModal from "../Modal/CustomModal";
import toast from "react-hot-toast";
// import { useGetData } from "react";
function Index({ form, set, element }) {
  const [state, setstate] = useState({});
  //   const { GetData, data, loading } = useGetData();
  const filterData = id => {
    let oldData = [...form[element.nested]].filter(
      (card, count) => count != id
    );
    set({ ...form, [element.nested]: oldData });
    toast.success("مدرس با موفقیت حذف شد");
  };
  const checkEmpty = data => {
    if (data) {
      if (data.length == 0) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  const [modal, setModal] = useState(false);
  return (
    <Fragment>
      <div className="row">
        <CustomModal show={modal} handleClose={() => setModal(false)}>
          <div className="row">
            {element.forms.map((form, key) => {
              if (form.type == "img") {
                return (
                  <Fragment key={key}>
                    <DropFile
                      // value={form[element.key]}
                      accept={element.accept}
                      key={key}
                      set={e => {
                        setstate({ ...state, image: e });
                      }}
                    />
                  </Fragment>
                );
              }
              if (form.type == "input") {
                return (
                  <div key={key} className="col-md-4">
                    <div className="form-group">
                      <label>{form.name}</label>
                      <input
                        className="form-control"
                        onChange={e => {
                          setstate({
                            ...state,
                            [form.key]: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                );
              }
              return (
                <div key={key} className="col-md-4">
                  <div className="form-group">
                    <label>{form.name}</label>
                    <textarea
                      className="form-control"
                      onChange={e => {
                        setstate({
                          ...state,
                          [form.key]: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              );
            })}
            <div className="col">
              <button
                className="btn btn-danger"
                onClick={() => {
                  let newForm = [];
                  if ([element.nested] in form) {
                    newForm = [...form[element.nested]];
                  }
                  newForm.push(state);
                  set({ ...form, [element.nested]: newForm });
                  toast.success("مدرس با موفقیت ثبت شد");
                  setModal(false);
                }}
              >
                ثبت
              </button>
            </div>
          </div>
        </CustomModal>
      </div>
      <div className="row mt-3">
        {!checkEmpty(form[element.nested]) && (
          <div className="col-12">
            <h6 className="text-center">مدرسی ثبت نشده است</h6>
          </div>
        )}
        {form[element.nested] &&
          form[element.nested].map((card, count) => {
            return (
              <div key={count} className="col-md-4">
                <div className="card">
                  <img
                    className="card-img-top"
                    // src={card.image[0].preview}
                    alt="Card image cap"
                  />
                  <div className="card-body">
                    <h5 className="card-title">{card.name}</h5>
                    <div className="d-flex flex-column">
                      <h6>رزرومه</h6>
                      <p style={{ fontSize: "12px" }}>{card.cv}</p>
                    </div>
                    <div className="d-flex flex-column">
                      <h6>مدارک</h6>
                      <p style={{ fontSize: "12px" }}>{card.proof}</p>
                    </div>
                    <div className="d-flex flex-column">
                      <h6>سابقه فعالیت</h6>
                      <p style={{ fontSize: "12px" }}>{card.activity}</p>
                    </div>
                    <div className="d-flex flex-column">
                      <h6>جزییات</h6>
                      <p style={{ fontSize: "12px" }}>{card.details}</p>
                    </div>
                    <button
                      onClick={() => filterData(count)}
                      href="#"
                      className="btn btn-primary text-white btn-block"
                    >
                      حذف
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <div className="row">
        <div className="col">
          <div className="d-flex justify-content-center">
            <button onClick={() => setModal(true)} className="btn btn-primary">
              <span>ثبت مدرس جدید</span>
              <i className="fas fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Index;
